import { DATE_WISE_PRODUCTION_REQUEST, CREATE_DATE_WISE_PRODUCTION, GET_DATE_WISE_PRODUCTIONS, GET_DATE_WISE_PRODUCTIONS_PAGE, UPDATE_DATE_WISE_PRODUCTION, DELETE_DATE_WISE_PRODUCTION, DATE_WISE_PRODUCTION_REQUEST_FAILURE, DATE_WISE_PRODUCTION_REQUEST_SUCCESS } from '../types';

const initialState = {
  dateWiseProductions: [],
  dateWiseProductionsPage: [],
  loading: false,
  error: null,
};



const dateWiseProductionReducer = (state = initialState, action) => {
  switch (action.type) {
    case DATE_WISE_PRODUCTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DATE_WISE_PRODUCTIONS: {
      return {
        ...state,
        dateWiseProductions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_DATE_WISE_PRODUCTIONS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
        ...state,
        dateWiseProductionsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
        }
    }
    case CREATE_DATE_WISE_PRODUCTION:
      return {
        ...state,
        dateWiseProductions: [action.payload, ...state.dateWiseProductions],
        loading: false,
        error: null
      };
    case UPDATE_DATE_WISE_PRODUCTION:
      const dateWiseProductionsData = state.dateWiseProductions.slice(0);
      const uIndex = dateWiseProductionsData.findIndex((data) => data.id === action.payload.id);
      dateWiseProductionsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        dateWiseProductions: [ ...dateWiseProductionsData ],
        loading: false,
        error: null
      };
    case DELETE_DATE_WISE_PRODUCTION:
      const dateWiseProductions = state.dateWiseProductions?.slice(0);
      const index = dateWiseProductions.findIndex((data) => data.id === action.id);
      if (index > -1) {
        dateWiseProductions.splice(index, 1);
      }
      return {
        ...state,
        dateWiseProductions: [...dateWiseProductions],
        loading: false,
        error: null
      }
    case DATE_WISE_PRODUCTION_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case DATE_WISE_PRODUCTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default dateWiseProductionReducer;
